import { useEffect } from "react";

import { useWindowSize } from "@newsela/angelou";
import { useTracker as useTrackerSnitch } from "@newsela/snitch";
import { useRouter } from "next/router";

import trackPageView from "./trackPageView";

// Routes that fire their own enriched Page View event and therefore
// suppress the default one fired here.
const SELF_TRACKING_ROUTES = new Set([
  "/content/subject/[contentId]",
  "/lesson-sparks/[contentId]",
  "/view/[contentId]",
]);

const useTrackPageView = () => {
  const router = useRouter();
  const { trackAction, getEventName } = useTrackerSnitch();

  const windowSize = useWindowSize();
  // For home page view event, track screen size
  const extraProperties = { screen_size: null };
  if (router.pathname === "/home") {
    extraProperties.screen_size = windowSize;
  }

  useEffect(() => {
    if (SELF_TRACKING_ROUTES.has(router.pathname)) {
      return;
    }

    trackPageView(trackAction, getEventName, undefined, extraProperties);
    // extraProperties is a new object every render — intentionally excluded.
  }, [router.pathname, trackAction, getEventName]);
};

export default useTrackPageView;
